import { Activity } from 'lucide-react';
import EstadoDelServidor from '../ops/EstadoDelServidor';

/* =====================================================================
   Las pantallas del carril `ops` · OPS-PUBLICA.md
   =====================================================================
   «Estado del servidor» va en Administración, junto a «Este servidor»:
   aquél dice qué es esta máquina y qué manda a la nube; éste dice cómo
   está AHORA (procesador, memoria, temperatura, disco, red, servicios,
   respaldo, actualizaciones) y cómo estuvo (histórico de 7 días), con
   cada tarjeta explicándose sola. Lo ve un ADMIN.
   ===================================================================== */
export default {
  orden: 90,
  grupos: [{
    grupo: 'Administración',
    items: [
      { id: 'estado-servidor', etiqueta: 'Estado del servidor', icono: Activity, min: 'ADMIN', Comp: EstadoDelServidor },
    ],
  }],
};
